import { use_component_is_mounted_50 } from '@/hooks/is_mounted/use_component_is_mounted_50';
import { cn } from '@/utils/utils_client';
import { CALLBACK__void } from '@shared/types/types';
import React from 'react';

interface Props {
  onClick?: CALLBACK__void;
  className?: string;
}

export const PLACEHOLDER_bar_line = React.forwardRef<HTMLDivElement, Props>(({ onClick, className }, ref) => {
  const { is_mounted } = use_component_is_mounted_50();

  return (
    <div
      ref={ref}
      {...{ onClick }}
      className={cn(
        `flex-center gap-2 px-2
                  size-full 
                  bg-bar text-bar-foreground 
                  ${onClick ? 'cursor-pointer' : ''}
                `,
        className,
      )}
    >
      <span className={`bg-bar-border h-1 rounded hover-animation  ${is_mounted ? 'w-full opacity-100' : 'w-36 opacity-50'}`} />
    </div>
  );
});
